import moment from "moment";

export enum TimeUnit {
  DAY = "day",
  WEEK = "week",
  MONTH = "month",
}

export const chartColors = [
  "rgb(237, 92, 123)",
  "rgb(48, 144, 209)",
  "rgb(251, 192, 45)",
  "rgb(153, 102, 255)",
  "rgb(75, 192, 192)",
  "rgb(255, 159, 64)",
  "rgb(201, 203, 207)",
  "rgb(63,81,181)",
  "rgb(0,150,136)",
  "rgb(161,136,127)",
  "rgb(255,120,100)",
  "rgb(75,180, 100)",
  "rgb(200,150, 255)",
  "rgb(30, 180, 250)",
  "rgb(90,81,181)",
  "rgb(255, 70, 160)",
  "rgb(255, 255, 0)",
  "rgb(255, 130, 160)",
  "rgb(237, 43, 46)",
  "rgb(206, 90, 76)",
];

export const makeBgColor = (color: string) =>
  color.replace(")", ", 0.2)").replace("rgb", "rgba");

export const bgColors = chartColors.map(makeBgColor);

export const labelFormat = {
  [TimeUnit.DAY]: "YYYY-MM-DD",
  [TimeUnit.WEEK]: "YYYY-MM-DD",
  [TimeUnit.MONTH]: "YYYY-MM",
};

export const labelFormatter = {
  [TimeUnit.DAY]: (value: string) => moment(value).format("YYYY-MM-DD"),
  [TimeUnit.WEEK]: (value: string) => moment(value).format("YYYY-MM-DD"),
  [TimeUnit.MONTH]: (value: string) => moment(value).format("YYYY-MM"),
};
